const CONTENT_COMPONENTS = new Set(['textarea', 'text', 'url', 'file', 'image', 'imageMultiple', 'multiImageUpload', 'fileMultiple', 'imageMask', 'audio', 'audioWaveform', 'video', 'videoTrimmer', 'pointCloud']);
const SECONDARY_NAMES = /^(negative[_-]?prompt|seed|style|tone|camera[_-]?motion|background|format|output[_-]?format)$/i;

export function getToolFieldGroups(fields) {
  const primary = [];
  const options = [];
  fields.forEach((field, index) => {
    const component = field.ui?.component;
    const defaultValue = field.validation?.default ?? field.value;
    const needsInput = field.validation?.required && (defaultValue == null || defaultValue === '' || (Array.isArray(defaultValue) && !defaultValue.length));
    const isContent = CONTENT_COMPONENTS.has(component) || (!component && ['string', 'file'].includes(field.type));
    (index === 0 || needsInput || (isContent && !SECONDARY_NAMES.test(field.name)) ? primary : options).push(field);
  });
  return { primary, options };
}

export function getToolOptionsSummary(fields, values) {
  return fields.flatMap(field => {
    const value = values[field.name];
    if (value == null || value === '' || typeof value === 'object' || typeof value === 'boolean') return [];
    const option = field.validation?.options?.find(item => String(item.value) === String(value));
    const label = option?.label || String(value);
    return label.length <= 32 ? [label] : [];
  }).slice(0, 3).join(' · ');
}
